import { Divider, MenuItem, Typography } from '@mui/material';
import { formatFrontendBuildTimeLabel } from '../../utils/frontendBuildTime';

/** Divider + non-interactive build timestamp for profile dropdowns (production build / CI time). */
export function FrontendBuildMenuFooter() {
    const label = formatFrontendBuildTimeLabel();
    if (!label) {
        return null;
    }
    return (
        <>
            <Divider />
            <MenuItem
                disabled
                dense
                sx={{
                    opacity: 1,
                    cursor: 'default',
                    pointerEvents: 'none',
                    '&.Mui-disabled': { opacity: 1 },
                }}
            >
                <Typography variant="caption" color="text.secondary" component="span">
                    Release: {label}
                </Typography>
            </MenuItem>
        </>
    );
}
